<template>
  <li style="list-style: none;">
    <div>
      <span @click="toggle" class="mr-2 cursor-pointer" v-if="item.children && item.children.length">
        <font-awesome-icon icon="plus-circle" v-if="!isOpen" />
        <font-awesome-icon icon="minus-circle" v-if="isOpen" />
      </span>
      <span @click="$emit('updateSelected', item)"
            class="cursor-pointer"
            :class="{ 'tree-item-empty': item.children && !item.children.length}"
      >
        {{ item.name }}
      </span>
    </div>
    <ul v-show="isOpen" style="list-style: none;">
      <OrganizationTreeViewItem
        v-for="(child, index) in item.children"
        :key="index"
        @updateSelected="$emit('updateSelected', $event)"
        :item="child"
      ></OrganizationTreeViewItem>
    </ul>
  </li>
</template>

<script>
import piincHttp from '@/util/configureAxios.js';
import OrganizationTreeViewItem from '@/components/organizations/OrganizationTreeViewItem.vue';

export default {
  name: 'OrganizationTreeViewItem',
  data: function() {
    return {
      isOpen: false
    }
  },
  props: {
    item: Object
  },
  watch: {

  },
  components: {
    OrganizationTreeViewItem
  },
  computed: {

  },
  methods: {
    toggle: function () {
      this.isOpen = !this.isOpen
    }
  },
  created () {

  }
}
</script>
